// ============================================
// PRIMARY SOCIAL SCIENCE CURRICULUM - YEAR 4
// Based on Vanuatu National Syllabus
// ============================================

export const socialScienceYear4 = {
  year: 4,
  subject: 'Social Science',
  totalWeeks: 40,
  periodsPerWeek: 4,
  terms: [
    {
      term: 'Term 1',
      weeks: 10,
      focus: 'Our Island Environment',
      scheme: [
        {
          week: 1,
          topic: 'Who Am I and Where Do I Live?',
          strand: 'Healthy Living',
          learningOutcomes: ['Identify personal identity and place of belonging', 'Describe their community and island', 'Locate their island on a map of Vanuatu'],
          activities: ['Self-identity activities', 'Community mapping', 'Island location exercise'],
          resources: ['Maps of Vanuatu', 'Community pictures', 'Identity worksheets']
        },
        {
          week: 2,
          topic: 'Where is Vanuatu?',
          strand: 'Healthy Living',
          learningOutcomes: ['Locate Vanuatu on a world map', 'Identify neighbouring countries in the Pacific', 'Describe Vanuatu as an island nation'],
          activities: ['World map exploration', 'Pacific region identification', 'Island nation discussion'],
          resources: ['World maps', 'Pacific region maps', 'Atlas']
        },
        {
          week: 3,
          topic: 'The Physical Features of Vanuatu',
          strand: 'Healthy Living',
          learningOutcomes: ['Identify physical features such as mountains, rivers, coasts', 'Describe the landscape of their island', 'Compare physical features across different islands'],
          activities: ['Physical feature identification', 'Landscape description', 'Feature comparison'],
          resources: ['Topographic maps', 'Landscape photos', 'Feature cards']
        },
        {
          week: 4,
          topic: 'Physical Features Caused by Natural Disasters',
          strand: 'Healthy Living',
          learningOutcomes: ['Identify natural disasters that affect Vanuatu (cyclones, earthquakes, volcanoes)', 'Describe how natural disasters change physical features', 'Discuss safety measures during disasters'],
          activities: ['Disaster identification', 'Impact discussion', 'Safety planning'],
          resources: ['Disaster photos', 'News articles', 'Safety guidelines']
        },
        {
          week: 5,
          topic: 'How Our Ancestors Arrived Here',
          strand: 'Healthy Living',
          learningOutcomes: ['Describe how ancestors migrated to Vanuatu', 'Identify traditional navigation methods', 'Appreciate the history of settlement'],
          activities: ['Migration story telling', 'Navigation methods discussion', 'Historical timeline'],
          resources: ['Migration maps', 'Traditional stories', 'Timeline materials']
        },
        {
          week: 6,
          topic: 'Traditional Use of the Land and Sea',
          strand: 'Healthy Living',
          learningOutcomes: ['Describe traditional farming and fishing practices', 'Identify resources from land and sea', 'Explain the importance of sustainable use'],
          activities: ['Traditional practices research', 'Resource identification', 'Sustainability discussion'],
          resources: ['Traditional farming guides', 'Fishing practice photos', 'Resource cards']
        },
        {
          week: 7,
          topic: 'Modern Ways of Conserving and Using the Land and Sea',
          strand: 'Healthy Living',
          learningOutcomes: ['Compare traditional and modern conservation methods', 'Identify modern threats to the environment', 'Suggest ways to protect natural resources'],
          activities: ['Comparison activities', 'Threat identification', 'Conservation planning'],
          resources: ['Conservation materials', 'Environmental articles', 'Planning templates']
        },
        {
          week: 8,
          topic: 'Plastic and the Environment',
          strand: 'Healthy Living',
          learningOutcomes: ['Identify the impact of plastic on the environment', 'Describe how plastic affects marine life', 'Suggest ways to reduce plastic use'],
          activities: ['Plastic audit', 'Marine impact discussion', 'Reduce-reuse-recycle planning'],
          resources: ['Plastic samples', 'Environmental photos', 'Action plan templates']
        },
        {
          week: 9,
          topic: 'Caring for the Environment',
          strand: 'Healthy Living',
          learningOutcomes: ['Describe ways to care for the local environment', 'Plan an environmental action project', 'Demonstrate responsible environmental behaviour'],
          activities: ['Environmental care brainstorm', 'Action project planning', 'School/community cleanup'],
          resources: ['Action plan templates', 'Cleaning supplies', 'Project materials']
        },
        {
          week: 10,
          topic: 'Me and My Environment',
          strand: 'Healthy Living',
          learningOutcomes: ['Reflect on personal relationship with the environment', 'Present learning about the island environment', 'Commit to environmental responsibility'],
          activities: ['Reflection activities', 'Presentation preparation', 'Commitment pledges'],
          resources: ['Presentation materials', 'Pledge cards', 'Assessment sheets']
        }
      ]
    },
    {
      term: 'Term 2',
      weeks: 10,
      focus: 'Culture',
      scheme: [
        {
          week: 1,
          topic: 'Culture',
          strand: 'Living Together',
          learningOutcomes: ['Define what culture means', 'Identify elements of their own culture', 'Recognise that different communities have different cultures'],
          activities: ['Culture definition discussion', 'Cultural elements brainstorm', 'Culture comparison'],
          resources: ['Cultural artefacts', 'Discussion guides', 'Comparison charts']
        },
        {
          week: 2,
          topic: 'The Importance of Cultural Groups',
          strand: 'Living Together',
          learningOutcomes: ['Identify different cultural groups in Vanuatu', 'Explain why cultural groups are important', 'Describe the role of cultural groups in the community'],
          activities: ['Cultural group mapping', 'Importance discussion', 'Role identification'],
          resources: ['Vanuatu cultural maps', 'Group discussion guides', 'Worksheets']
        },
        {
          week: 3,
          topic: 'Cultural Identity',
          strand: 'Living Together',
          learningOutcomes: ['Describe their own cultural identity', 'Identify factors that shape cultural identity', 'Respect the cultural identity of others'],
          activities: ['Identity exploration', 'Factor identification', 'Respect activities'],
          resources: ['Identity worksheets', 'Cultural artefacts', 'Discussion guides']
        },
        {
          week: 4,
          topic: 'Cultural Values and Beliefs',
          strand: 'Living Together',
          learningOutcomes: ['Identify cultural values in their community', 'Describe cultural beliefs and their significance', 'Compare values across different cultures'],
          activities: ['Values identification', 'Beliefs discussion', 'Cross-cultural comparison'],
          resources: ['Values cards', 'Story resources', 'Comparison charts']
        },
        {
          week: 5,
          topic: 'Religious Moral Values and Beliefs',
          strand: 'Living Together',
          learningOutcomes: ['Identify major religions in Vanuatu', 'Describe moral values from religious teachings', 'Explain how religious values guide behaviour'],
          activities: ['Religion identification', 'Moral values discussion', 'Behaviour connection'],
          resources: ['Religion resources', 'Moral story cards', 'Discussion guides']
        },
        {
          week: 6,
          topic: 'Religious Occasions and Practices',
          strand: 'Living Together',
          learningOutcomes: ['Identify religious occasions celebrated in Vanuatu', 'Describe practices associated with religious occasions', 'Show respect for different religious practices'],
          activities: ['Occasion calendar creation', 'Practice description', 'Respect discussion'],
          resources: ['Religious calendar', 'Practice photos', 'Discussion materials']
        },
        {
          week: 7,
          topic: 'Who Are Our Melanesian Neighbours?',
          strand: 'Living Together',
          learningOutcomes: ['Identify Melanesian countries and territories', 'Locate Melanesian neighbours on a map', 'Describe connections between Melanesian peoples'],
          activities: ['Map identification', 'Neighbour research', 'Connection discussion'],
          resources: ['Pacific maps', 'Country fact sheets', 'Research materials']
        },
        {
          week: 8,
          topic: 'Characteristics of Melanesians',
          strand: 'Living Together',
          learningOutcomes: ['Describe common characteristics of Melanesian peoples', 'Identify similarities and differences among Melanesians', 'Appreciate Melanesian diversity'],
          activities: ['Characteristic identification', 'Similarity/difference sorting', 'Appreciation activities'],
          resources: ['Melanesian photos', 'Comparison charts', 'Research materials']
        },
        {
          week: 9,
          topic: 'Custom, Tradition and Way of Life in Melanesia',
          strand: 'Living Together',
          learningOutcomes: ['Describe customs and traditions of Melanesian peoples', 'Compare ways of life across Melanesia', 'Identify shared cultural practices'],
          activities: ['Custom exploration', 'Way of life comparison', 'Shared practice identification'],
          resources: ['Cultural stories', 'Comparison materials', 'Research guides']
        },
        {
          week: 10,
          topic: 'Cultural Display',
          strand: 'Living Together',
          learningOutcomes: ['Plan and prepare a cultural display', 'Present cultural learning through display', 'Demonstrate appreciation for cultural diversity'],
          activities: ['Display planning', 'Display creation', 'Cultural presentation'],
          resources: ['Display materials', 'Cultural artefacts', 'Presentation space']
        }
      ]
    },
    {
      term: 'Term 3',
      weeks: 10,
      focus: 'Living Together - Needs, Wants, Jobs and Rules',
      scheme: [
        {
          week: 1,
          topic: 'Things I Need or Want Every Day',
          strand: 'Living Together',
          learningOutcomes: ['Distinguish between needs and wants', 'Identify daily needs for survival', 'Recognise that wants change over time'],
          activities: ['Needs vs wants sorting', 'Daily needs listing', 'Wants discussion'],
          resources: ['Sorting cards', 'Picture cards', 'Worksheets']
        },
        {
          week: 2,
          topic: 'Basic Needs and Wants',
          strand: 'Living Together',
          learningOutcomes: ['Identify basic human needs (food, water, shelter, clothing)', 'Explain why basic needs must be met first', 'Discuss how families meet their basic needs'],
          activities: ['Basic needs identification', 'Priority discussion', 'Family needs exploration'],
          resources: ['Needs cards', 'Priority worksheets', 'Family discussion guides']
        },
        {
          week: 3,
          topic: 'Paid and Unpaid Jobs',
          strand: 'Living Together',
          learningOutcomes: ['Identify different types of jobs in the community', 'Distinguish between paid and unpaid work', 'Explain the value of both paid and unpaid work'],
          activities: ['Job identification', 'Paid/unpaid sorting', 'Value discussion'],
          resources: ['Job picture cards', 'Sorting activities', 'Discussion guides']
        },
        {
          week: 4,
          topic: 'Importance of Rules',
          strand: 'Living Together',
          learningOutcomes: ['Explain why rules are important', 'Identify rules at home, school and community', 'Describe what happens when rules are broken'],
          activities: ['Rule importance discussion', 'Rule identification', 'Consequence exploration'],
          resources: ['Rule charts', 'Scenario cards', 'Discussion materials']
        },
        {
          week: 5,
          topic: 'How Decisions and Rules Are Made',
          strand: 'Living Together',
          learningOutcomes: ['Describe how decisions are made in families and communities', 'Identify who makes rules', 'Participate in a democratic decision-making activity'],
          activities: ['Decision-making exploration', 'Rule-maker identification', 'Class vote activity'],
          resources: ['Decision-making guides', 'Voting materials', 'Role play cards']
        },
        {
          week: 6,
          topic: 'Needs, Wants and Jobs - Revision',
          strand: 'Living Together',
          learningOutcomes: ['Consolidate understanding of needs, wants and jobs', 'Apply knowledge to real-life scenarios', 'Prepare for assessment'],
          activities: ['Review activities', 'Scenario-based practice', 'Assessment preparation'],
          resources: ['Revision worksheets', 'Scenario cards', 'Self-assessment sheets']
        },
        {
          week: 7,
          topic: 'Community Helpers and Services',
          strand: 'Living Together',
          learningOutcomes: ['Identify community helpers and their roles', 'Describe services available in the community', 'Explain how community services meet peoples needs'],
          activities: ['Community helper identification', 'Service mapping', 'Role discussion'],
          resources: ['Community helper cards', 'Service maps', 'Discussion guides']
        },
        {
          week: 8,
          topic: 'Working Together in the Community',
          strand: 'Living Together',
          learningOutcomes: ['Describe how people work together in communities', 'Identify examples of cooperation', 'Participate in a group community project'],
          activities: ['Cooperation examples', 'Group project planning', 'Community contribution'],
          resources: ['Cooperation stories', 'Project materials', 'Group work guides']
        },
        {
          week: 9,
          topic: 'Rights and Responsibilities',
          strand: 'Living Together',
          learningOutcomes: ['Identify basic rights of children', 'Describe responsibilities that come with rights', 'Explain how rights and responsibilities are connected'],
          activities: ['Rights identification', 'Responsibility matching', 'Connection discussion'],
          resources: ['Rights cards', 'Responsibility charts', 'Discussion materials']
        },
        {
          week: 10,
          topic: 'Term 3 Assessment - Living Together',
          strand: 'Living Together',
          learningOutcomes: ['Demonstrate understanding of needs, wants and jobs', 'Show knowledge of rules and decision-making', 'Apply community and cooperation concepts'],
          activities: ['Written assessment', 'Practical tasks', 'Presentation'],
          resources: ['Assessment papers', 'Task materials', 'Recording sheets']
        }
      ]
    },
    {
      term: 'Term 4',
      weeks: 10,
      focus: 'Enterprise - Planning and Carrying Out Projects',
      scheme: [
        {
          week: 1,
          topic: 'What is a Plan or Project?',
          strand: 'Enterprise',
          learningOutcomes: ['Define what a plan and project are', 'Identify examples of plans and projects', 'Explain why planning is important'],
          activities: ['Plan/project definition', 'Example identification', 'Planning importance discussion'],
          resources: ['Plan examples', 'Project photos', 'Discussion guides']
        },
        {
          week: 2,
          topic: 'My Plans',
          strand: 'Enterprise',
          learningOutcomes: ['Create a personal plan for a simple activity', 'Identify steps needed to carry out a plan', 'Set goals for their project'],
          activities: ['Personal plan creation', 'Step identification', 'Goal setting'],
          resources: ['Planning templates', 'Step-by-step guides', 'Goal-setting worksheets']
        },
        {
          week: 3,
          topic: 'How to Raise Funds',
          strand: 'Enterprise',
          learningOutcomes: ['Identify different ways to raise funds', 'Describe fundraising activities suitable for school', 'Plan a simple fundraising activity'],
          activities: ['Fundraising brainstorm', 'Activity evaluation', 'Fundraising plan creation'],
          resources: ['Fundraising idea cards', 'Planning templates', 'Budget worksheets']
        },
        {
          week: 4,
          topic: 'Project Plans',
          strand: 'Enterprise',
          learningOutcomes: ['Develop a detailed project plan', 'Include timeline, resources and roles in the plan', 'Present the project plan to the class'],
          activities: ['Detailed plan development', 'Resource and role assignment', 'Plan presentation'],
          resources: ['Project plan templates', 'Timeline materials', 'Presentation materials']
        },
        {
          week: 5,
          topic: 'Carrying Out the Project',
          strand: 'Enterprise',
          learningOutcomes: ['Implement the project plan', 'Work cooperatively in groups', 'Document the project progress'],
          activities: ['Project implementation', 'Group cooperation', 'Progress documentation'],
          resources: ['Project materials', 'Documentation tools', 'Group work guides']
        },
        {
          week: 6,
          topic: 'Project Review and Evaluation',
          strand: 'Enterprise',
          learningOutcomes: ['Review the outcomes of the project', 'Evaluate what went well and what could improve', 'Present project outcomes to the class'],
          activities: ['Project review', 'Evaluation discussion', 'Outcome presentation'],
          resources: ['Review templates', 'Evaluation forms', 'Presentation materials']
        },
        {
          week: 7,
          topic: 'Saving and Budgeting',
          strand: 'Enterprise',
          learningOutcomes: ['Explain the importance of saving money', 'Create a simple budget', 'Describe ways to manage money wisely'],
          activities: ['Saving importance discussion', 'Budget creation', 'Money management scenarios'],
          resources: ['Budget templates', 'Play money', 'Scenario cards']
        },
        {
          week: 8,
          topic: 'Enterprise in Our Community',
          strand: 'Enterprise',
          learningOutcomes: ['Identify small enterprises in the community', 'Describe how enterprises meet community needs', 'Discuss the role of enterprise in development'],
          activities: ['Community enterprise identification', 'Needs-meeting discussion', 'Development role exploration'],
          resources: ['Community enterprise photos', 'Interview guides', 'Discussion materials']
        },
        {
          week: 9,
          topic: 'End-of-Year Revision - Social Science',
          strand: 'All Strands',
          learningOutcomes: ['Review key concepts from all terms', 'Consolidate knowledge of environment, culture, living together and enterprise', 'Prepare for end-of-year assessment'],
          activities: ['Comprehensive revision', 'Key concept review', 'Assessment preparation'],
          resources: ['Revision materials', 'Study guides', 'Practice questions']
        },
        {
          week: 10,
          topic: 'End-of-Year Assessment',
          strand: 'All Strands',
          learningOutcomes: ['Demonstrate understanding of island environment and culture', 'Show knowledge of living together and enterprise', 'Apply social science skills to real-life contexts'],
          activities: ['End-of-year examination', 'Practical assessment', 'Portfolio finalisation'],
          resources: ['Examination papers', 'Assessment materials', 'Portfolio folders']
        }
      ]
    }
  ]
};

export default socialScienceYear4;
